import React from 'react';
import { useI18n } from '../context/I18nContext';
import { Globe, Search, Shield, Lock, Sparkles, Network } from 'lucide-react';

const WHY_ICONS = [Globe, Search, Shield, Lock, Sparkles, Network];

export default function About() {
  const { t } = useI18n();
  const whyItems = t('home.why_items');

  return (
    <div data-testid="about-page">
      <section className="max-w-[1100px] mx-auto px-6 lg:px-12 py-16 lg:py-24 text-center">
        <h1 className="font-serif text-5xl md:text-7xl text-[#f5f5f0]">{t('about.title')}</h1>
      </section>

      <section className="bg-[#05150f] py-24">
        <div className="max-w-[1100px] mx-auto px-6 lg:px-12">
          <p className="gn-overline mb-5" data-testid="about-story-eyebrow">{t('about.story_t')}</p>
          <h2 className="font-serif text-4xl md:text-5xl text-[#f5f5f0] mb-10 leading-tight">{t('about.story_t')}</h2>
          <div className="space-y-6 max-w-3xl">
            <p className="text-lg md:text-xl text-[#a3b5ad] font-light leading-relaxed" data-testid="about-story-p1">{t('about.story_b1')}</p>
            <p className="text-lg md:text-xl text-[#a3b5ad] font-light leading-relaxed" data-testid="about-story-p2">{t('about.story_b2')}</p>
          </div>
        </div>
      </section>

      <section className="py-24">
        <div className="max-w-[1100px] mx-auto px-6 lg:px-12">
          <p className="gn-overline mb-5" data-testid="about-approach-eyebrow">{t('about.approach_t')}</p>
          <h2 className="font-serif text-4xl md:text-5xl text-[#f5f5f0] mb-10 leading-tight">{t('about.approach_t')}</h2>
          <div className="space-y-6 max-w-3xl">
            <p className="text-lg md:text-xl text-[#a3b5ad] font-light leading-relaxed" data-testid="about-approach-p1">{t('about.approach_b1')}</p>
            <p className="text-lg md:text-xl text-[#a3b5ad] font-light leading-relaxed" data-testid="about-approach-p2">{t('about.approach_b2')}</p>
          </div>
        </div>
      </section>

      {/* WHY GN WATCHES */}
      <section className="bg-[#05150f] py-24 lg:py-32" data-testid="why-section">
        <div className="max-w-[1440px] mx-auto px-6 lg:px-12">
          <p className="gn-overline mb-4 text-center">{t('home.why_eyebrow')}</p>
          <h2 className="font-serif text-4xl md:text-5xl text-center text-[#f5f5f0] mb-20">GN Watches</h2>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-px bg-[#c9a961]/15">
            {Array.isArray(whyItems) && whyItems.map((item, i) => {
              const Icon = WHY_ICONS[i] || Sparkles;
              return (
                <div key={item} className="bg-[#05150f] p-10 hover:bg-[#0d2a1f] transition-colors group">
                  <Icon size={32} className="text-[#c9a961] mb-6 group-hover:scale-110 transition-transform" strokeWidth={1.2} />
                  <h3 className="font-serif text-2xl text-[#f5f5f0]">{item}</h3>
                </div>
              );
            })}
          </div>
        </div>
      </section>
    </div>
  );
}
